// REACT
import React, {Component} from 'react';

// REDUX
import {connect} from 'react-redux';
import * as actions from '../actions';

// VENDOR COMPONENTS
import AutoComplete from 'material-ui/AutoComplete';

// CUSTOM COMPONENTS
import { FluidSection } from '../components/FluidSection';
import { StretchCard } from '../components/StretchCard';
import { Content } from '../components/Content';

// UTILS
import { constants } from '../constants/index';

  
class ExpertSearch extends Component {

    state = {
        searchInputValues: [],
    };

      //for Mui Auto complete
    handleUpdateInput = (value) => {
        this.setState({
            searchInputValues: [
            value,
            // value + value,
            // value + value + value,
            ],
        });
    };

    componentWillMount() {
        this.props.getDBProviders();
    }

    componentDidMount(){
        // document.getElementById('top').scrollIntoView();
        // must load here not in AppRouter
        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
    }
     
    render() {
        const {searchInputValues} = this.state;
        // TODO: note that serviceCategories shold be attached to services not experts in the future
        let filteredProvider = [];
        if (this.props.providers) { 
            filteredProvider = this.props.providers.filter(provider => {
                let providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
                
                let fileredProviderMatch = false;
                        // provider.fullName.forEach(serviceCategory => {
                            if (searchInputValues && searchInputValues.indexOf(providerFullName) > -1) {
                                fileredProviderMatch = true;
                            }
                        // })
                    return fileredProviderMatch;
                }
            );
        }

        let unFilteredProviders = [];
        if (this.props.providers) { 
                unFilteredProviders = this.props.providers.filter(provider => {
                    let providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
                    let fileredProviderMatch = false;
                        // expert.serviceCategories.forEach(serviceCategory =>{
                            if (! (searchInputValues && searchInputValues.indexOf(providerFullName) > -1)) {
                                fileredProviderMatch = true;
                            } 
                        // })
                    return fileredProviderMatch;
                }
            );
        }

        // console.log(searchInputValues)
       
        let dataSourceNodes;
        let providers = [];
        if (this.props.providers) { 
            providers = this.props.providers
            dataSourceNodes = providers.map(provider => {
                // console.log('PROVIDER @ dataSource Nodes Expert Search', provider);
                if (provider.name) {
                    return (
                        `${provider.name.first} ${provider.name.last}`
                    )
                }
                return null;
            });
        }
            
        return (
            <div style={constants.layout.container}>
                <div ref="experts"></div>

                { dataSourceNodes &&
                    <FluidSection>
                        <AutoComplete
                            hintText="Search Experts"
                            dataSource={dataSourceNodes}
                            onUpdateInput={this.handleUpdateInput}
                            filter={AutoComplete.fuzzyFilter}
                            />
                    </FluidSection>
                }
                { filteredProvider && ( searchInputValues && searchInputValues.length > 0 ) &&
                    <div>
                    <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={100} sectionMaxWidth={157}>
                        { filteredProvider &&
                            filteredProvider.map((provider)=>{
                                const providerService = this.props.services.map(service => {
                                    if (service.provider === provider.uid){
                                        return (
                                            <StretchCard
                                                key={provider.uid}
                                                cardImageHeight={225}
                                                linkURL={`/expert/${provider.uid}`}
                                                backgroundImageURL={provider.profilePhotoURL}
                                                // avatarURL={provider.avatarURL}
                                                // logoURL={provider.logoImageURL}
                                                typeTitleText={provider.expertise}
                                                mainTitleText={`${provider.name && provider.name.first} ${provider.name && provider.name.last}`}
                                                // serviceTitleText={`${provider.name.first} ${provider.name.last}`}
                                                subTitleText={`Services starting at – $${service.price/100}`}
                                                cardTypeTitleColor={'#4AC4D1'}
                                                flexDirection={'column-reverse'}
                                                fontSizeDivider={1.2}

                                                // hoverIcons
                                            />
                                        );
                                    }
                                })
                                return providerService.filter(card => card);
                            })
                        }
                    </FluidSection>
                    </div>
                }

                 { unFilteredProviders &&  (unFilteredProviders.length > 0) && this.props.services &&
                    <div>
                        <FluidSection style={{ marginBottom: -25, }}>
                            <Content 
                                mainTitleTextAlt={`${(!searchInputValues || searchInputValues.length === 0) ? 'All' : 'Other'} Experts`}
                            >
                            </Content>
                        </FluidSection>
                        <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={100} sectionMaxWidth={157}>
                            { unFilteredProviders &&
                                unFilteredProviders.map((provider)=>{
                                    const providerService = this.props.services.map(service => {
                                        if (service.provider === provider.uid){
                                            return (
                                                <StretchCard
                                                key={provider.uid}
                                                cardImageHeight={225}
                                                linkURL={`/expert/${provider.uid}`}
                                                backgroundImageURL={provider.profilePhotoURL}
                                                // avatarURL={provider.avatarURL}
                                                // logoURL={provider.logoImageURL}
                                                typeTitleText={provider.expertise}
                                                mainTitleText={`${provider.name && provider.name.first} ${provider.name && provider.name.last}`}
                                                // serviceTitleText={`${provider.name.first} ${provider.name.last}`}
                                                subTitleText={`Services starting at – $${service.price/100}`}
                                                cardTypeTitleColor={'#4AC4D1'}
                                                flexDirection={'column-reverse'}
                                                fontSizeDivider={1.2}

                                                // hoverIcons
                                            />
                                            );
                                        }
                                    })
                                    return providerService.filter(card => card);
                                })
                            }
                        </FluidSection>
                    </div>
                }

            
            </div>
        );
    }
}



const mapStateToProps = ({provider, expert, service, company}) => {
    // console.log(`%c${JSON.stringify(company)}`,'color: gold');
    return {
        providers: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.serviceModules,
        companies: company.providerCompanies,
    };
}


export default connect(mapStateToProps, actions)(ExpertSearch);



// WEBPACK FOOTER //
// ./src/js/containers/ExpertSearch.jsx